export const experimentExposuresFromService = (exposures) => {
    if (!exposures) {
        return undefined;
    }
    return exposures.map((exposure) => ({
        experimentId: exposure.experiment_id || "",
        experimentName: exposure.experiment_name || "",
        exposureCount: exposure.exposure_count || 0,
        exposurePercentage: exposure.exposure_percentage || 0,
        included: exposure.included || false
    }));
};
export const experimentExposuresToService = (exposures) => {
    if (!exposures) {
        return undefined;
    }
    return exposures.map((exposure) => ({
        experiment_id: exposure.experimentId,
        experiment_name: exposure.experimentName,
        exposure_count: exposure.exposureCount,
        exposure_percentage: exposure.exposurePercentage,
        included: exposure.included
    }));
};
//# sourceMappingURL=experimentExposures.js.map